import { KodakMomentsTheme } from 'swp-react';
import { ThemeProvider } from '@mui/material/styles';
import ClientLayout from '../components/ClientLayout';

import '../styles/globals.css';
import StoreProvider from '../store/StoreProvider';

// export async function getStaticProps() {
// 	// Fetch data from external API

// 	const facebookClientId = process.env.FACEBOOK_CLIENT_ID ?? '';
// 	// Pass data to the page via props
// 	return { props: { facebookClientId } };
// }

export default function App({ Component, pageProps }) {
	const getLayout = Component?.getLayout ? (
		Component?.getLayout(<Component {...pageProps} />)
	) : (
		<Component {...pageProps} />
	);

	return (
		<>
			<StoreProvider>
				<ThemeProvider theme={KodakMomentsTheme}>
					<ClientLayout>{getLayout}</ClientLayout>
				</ThemeProvider>
			</StoreProvider>
		</>
	);
}
